import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import MicroQualificationService from "../../services/MicroQualificationService";

let initialState = {
    microQualifications: [],
    isLoading: false,
    hasMore: false,
    error: null,
}
export const getAllMicroQualifications = createAsyncThunk(
    'getAllMicroQualifications',
    async ({page, limit, role, id}, {getState, rejectWithValue, dispatch}) => {
        try {
            const response = await MicroQualificationService.getMicroqualifications(page, limit, role, id);
            return response;
        } catch (error) {
            return rejectWithValue(error?.response?.data);
        }
    },
);

const microqualificationsSlice = createSlice({
    name: 'microQualificationSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllMicroQualifications.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getAllMicroQualifications.fulfilled, (state, action) => {
                state.isLoading = false;
                state.microQualifications = action.payload.data;
                state.hasMore = action.payload.hasMore;
            })
            .addCase(getAllMicroQualifications.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                state.microQualifications = [];
                state.hasMore = false;
            })
    }
});

export const {} = microqualificationsSlice.actions;

export default microqualificationsSlice.reducer;